module.exports = __webpack_public_path__ + "img/88085485004959.7f74d4a0.png";